import { useEffect, useRef, useState } from 'react'
import { CURRENT_ORIGIN, PREVIOUS_ORIGIN, importSavedPath } from './lib/transfer'

export default function TransferPage() {
  const [waiting, setWaiting] = useState(false)
  const [error, setError] = useState('')
  const cleanup = useRef<() => void>(() => {})
  useEffect(() => () => cleanup.current(), [])

  const transfer = () => {
    cleanup.current()
    setError('')
    if (window.location.origin !== CURRENT_ORIGIN) {
      window.location.assign(`${CURRENT_ORIGIN}/transfer`)
      return
    }
    const popup = window.open(`${PREVIOUS_ORIGIN}/path-bridge`, 'blomit-path-transfer', 'popup,width=520,height=560')
    if (!popup) { setError('Allow the transfer popup, then try again.'); return }
    const nonce = crypto.randomUUID()
    setWaiting(true)
    const receive = (event: MessageEvent) => {
      if (event.origin !== PREVIOUS_ORIGIN || event.source !== popup || event.data?.type !== 'blomit-transfer-response' || event.data.nonce !== nonce) return
      cleanup.current()
      setWaiting(false)
      if (event.data.error) { setError('The previous address could not read this browser’s saved path.'); return }
      try {
        const path = importSavedPath(event.data.storage, window.localStorage)
        window.location.replace(path)
      } catch (error) {
        setError(error instanceof Error ? error.message : 'The saved path could not be transferred.')
      }
    }
    window.addEventListener('message', receive)
    const interval = window.setInterval(() => {
      if (popup.closed) {
        cleanup.current()
        setWaiting(false)
        setError('The transfer window was closed. You can try again.')
        return
      }
      popup.postMessage({ type: 'blomit-transfer-request', nonce }, PREVIOUS_ORIGIN)
    }, 300)
    const timeout = window.setTimeout(() => {
      cleanup.current()
      setWaiting(false)
      setError('The previous address did not respond. Please try again.')
    }, 60_000)
    cleanup.current = () => {
      window.removeEventListener('message', receive)
      window.clearInterval(interval)
      window.clearTimeout(timeout)
      popup.close()
    }
  }

  return <section className="empty-page">
    <div className="eyebrow">Your new address / blomit</div>
    <h1>Bring your path<br /><em>with you.</em></h1>
    <p>Already used our previous address? In the same browser, bring your saved answers, learning path and progress to blomit.pages.dev.</p>
    <button className="button button-primary" disabled={waiting} onClick={transfer}>{waiting ? 'Bringing your path…' : 'Bring my saved path'}</button>
    {error && <p className="form-error" role="alert">{error}</p>}
    <p className="transfer-links"><a className="text-link" href="/plan">Open my current path</a> · <a className="text-link" href="/">Continue to blomit</a></p>
  </section>
}
